import { sumBy } from "lodash";
import { useMemo } from "react";

export const useSumOrderItems = (items: OrderItem[]) => {
  return useMemo(() => {
    return sumBy(items, "quantity");
  }, [items]);
};
